import { render, staticRenderFns } from "./AsignacionMandantePantalla.vue?vue&type=template&id=f3fb7e6c&scoped=true&"
import script from "./AsignacionMandantePantalla.vue?vue&type=script&lang=ts&"
export * from "./AsignacionMandantePantalla.vue?vue&type=script&lang=ts&"
import style0 from "./AsignacionMandantePantalla.vue?vue&type=style&index=0&id=f3fb7e6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3fb7e6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('f3fb7e6c', component.options)
    } else {
      api.reload('f3fb7e6c', component.options)
    }
    module.hot.accept("./AsignacionMandantePantalla.vue?vue&type=template&id=f3fb7e6c&scoped=true&", function () {
      api.rerender('f3fb7e6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/AsignacionMandante/AsignacionMandantePantalla.vue"
export default component.exports